"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TagPicker", {
    enumerable: true,
    get: function() {
        return TagPicker;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTagPicker = require("./useTagPicker");
const _renderTagPicker = require("./renderTagPicker");
const _useTagPickerContextValues = require("./useTagPickerContextValues");
const TagPicker = /*#__PURE__*/ _react.memo((props)=>{
    const state = (0, _useTagPicker.useTagPicker_unstable)(props);
    const contextValues = (0, _useTagPickerContextValues.useTagPickerContextValues)(state);
    return (0, _renderTagPicker.renderTagPicker_unstable)(state, contextValues);
});
TagPicker.displayName = 'TagPicker';
